/**
 * Secondary-query placeholders keep primary page content usable while enrichment data loads.
 */
import React from 'react';

const PULSE_KEYFRAMES_ID = 'enrichment-pulse-keyframes';
const PULSE_KEYFRAMES = `@keyframes enrichment-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}`;

// Keyframes are global, so one <style> in the head serves every instance instead of one per cell.
if (typeof document !== 'undefined' && !document.getElementById(PULSE_KEYFRAMES_ID)) {
  const style = document.createElement('style');
  style.id = PULSE_KEYFRAMES_ID;
  style.textContent = PULSE_KEYFRAMES;
  document.head.appendChild(style);
}

export const EnrichmentSkeleton: React.FC = () => (
  <div
    data-testid="enrichment-skeleton"
    style={{
      width: '100%',
      height: '1em',
      borderRadius: 4,
      backgroundColor: '#E9EBEF',
      animation: 'enrichment-pulse 1.5s ease-in-out infinite',
    }}
  />
);
